export const wait = (ms: number) => new Promise((res) => setTimeout(res, ms));

/**
 * Use with caution!
 * @deprecated There are very few times that it makes sense to use this.
 */
export const waitForever = () =>
  new Promise(() => {
    // never resolves the promise
  });
